import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthStore, UserRole } from '../store/auth.store';

export const roleGuard = (allowedRoles: UserRole[]): CanActivateFn => {
  return () => {
    const authStore = inject(AuthStore);
    const router = inject(Router);

    const currentRole = authStore.role();

    if (currentRole && allowedRoles.includes(currentRole)) {
      return true;
    }

    void router.navigate(['/auth/access-denied']);
    return false;
  };
};
